<section class="w-10/12 sm:w-9/12 mx-auto pt-16 pb-12">
  <h2 class="lg:text-center pb-2">
    {{ "main_page.case_studies_section.title" | translate }}
  </h2>
  <p class="lg:text-center max-w-3xl mx-auto pb-12">
    {{ "main_page.case_studies_section.subtitle" | translate }}
  </p>

  <div class="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
    @for (study of studies; track study.key) {
      <div class="pygCaseCard p-6">
        <div class="pygLogoWrap mb-3">
          <img
            [src]="study.logo"
            [alt]="('main_page.case_studies_section.' + study.key + '.company' | translate) + ' logo'"
            class="pygLogo"
          />
        </div>
        <h5 class="pygCompanyName mb-2">
          {{ "main_page.case_studies_section." + study.key + ".company" | translate }}
        </h5>
        <div class="pygIndustryTag mb-3">
          {{ "main_page.case_studies_section." + study.key + ".industry" | translate }}
        </div>
        <h4 class="pb-2">
          {{ "main_page.case_studies_section." + study.key + ".metric" | translate }}
        </h4>
        <p class="pygCaseDesc">
          {{ "main_page.case_studies_section." + study.key + ".description" | translate }}
        </p>
      </div>
    }
  </div>

  <div class="text-center mt-10">
    <a langRouterLink="case-studies" class="pygViewAll">
      {{ "main_page.case_studies_section.cta" | translate }}
    </a>
  </div>
</section>
